
















import { defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { format, formatDateOnly, getNow } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "AgeConfirmationForm",
  components: { BaseForm, BaseConfirm, BaseButton },
  props: {
    birthDate: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const isValid = ref(false);
    const values = ref<FormValues>({ birthDate: props.birthDate ? formatDateOnly(props.birthDate) : undefined });

    const minBirthDate = new Date(1900, 0);
    const maxBirthDate = getNow();
    const birthDateRange = [minBirthDate, maxBirthDate].map(date => format(date, "yyyy-MM-dd")).join();
    const fields: FormFields = [
      {
        name: "birthDate",
        label: $t("Birth date"),
        type: "date",
        min: minBirthDate,
        max: maxBirthDate,
        rules: ["required", `date_between:${birthDateRange}`],
      },
    ];

    const submit = () => {
      loading.value = true;
      emit("submit", values.value.birthDate, () => (loading.value = false));
    };

    return { loading, fields, values, isValid, submit };
  },
});
